export enum RequestCorrespondenceRecipientRole {
	Complainant = "COMPLAINANT",
	Respondent = "RESPONDENT",
	Reporter = "REPORTER",
}
